import { useEffect } from 'react';

const EachRow = (props:any)=>{
    const children = props.children;
    const index = props.index;
    const menuIndex = props.menuIndex;
    const onClick = props.onClick;
  
    useEffect(()=>{
      return () => onClick(null);
    },[])
    
    return (
        <div>
            {children}
        </div>  
    ) 
}

export default EachRow;

